import collectionReducer from './reducers'

export { default as collectionSelectors } from './selectors'
export { default as collectionActions } from './actions'
export { default as collectionTypes } from './actionTypes'

export default collectionReducer
